import React from "react";
import { Image, Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { TouchableOpacity } from "react-native-gesture-handler";
import { AppImages } from "../../utility/AppImages";

const GoLiveGeneralFeat = () => {
  const deviceSize = useDeviceSize();

  return (
    <View>
      <Text style={[AppFontStyle.REGULAR_ANYBODY_16, { marginVertical: 5 }]}>
        General Features
      </Text>
      <View
        style={{
          flexDirection: "row",
          backgroundColor: AppColors.grayColor_505050,
          padding: 10,
          columnGap: 70,
        }}
      >
        <Text
          style={[
            deviceSize === DEVICE_SIZES.XS
              ? AppFontStyle.REGULAR_ANYBODY_12
              : AppFontStyle.REGULAR_ANYBODY_16,
            { color: AppColors.gray_C3C3C3, flex: 1 },
          ]}
        >
          Camera
        </Text>
        <TouchableOpacity>
          <Image
            source={AppImages.arrowDown}
            style={{ height: 12, width: 15 }}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default GoLiveGeneralFeat;
